import script from "./reference-check-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./reference-check-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__